import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Heart, X, ArrowRight, FlaskConical } from "lucide-react";
import { toast } from "sonner";
import { meta } from "@/lib/peptideMeta";

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const [products, setProducts] = useState({});

  const load = async () => {
    const [wl, prods] = await Promise.all([api.get("/wishlist"), api.get("/peptides")]);
    setItems(wl.data);
    const map = {};
    prods.data.forEach((p) => (map[p.slug] = p));
    setProducts(map);
  };
  useEffect(() => { load(); }, []);

  const remove = async (slug) => { await api.delete(`/wishlist/${slug}`); toast.success("Removed"); load(); };

  return (
    <div data-testid="wishlist-page">
      <div className="mb-6">
        <div className="eyebrow mb-2">Wishlist</div>
        <h1 className="font-display text-3xl font-semibold text-slate-900 tracking-tight">Saved products.</h1>
      </div>
      {items.length === 0 ? (
        <div className="border border-dashed border-slate-200 rounded-md p-12 text-center text-slate-500">
          <Heart className="w-8 h-8 text-slate-300 mx-auto mb-3" strokeWidth={1.5}/>
          Your wishlist is empty. Browse the <Link to="/catalog" className="text-blue-700">catalog</Link> to add compounds.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((w) => {
            const p = products[w.peptide_slug];
            if (!p) return null;
            const m = meta(p.slug);
            return (
              <div key={p.slug} data-testid={`wishlist-${p.slug}`} className="border border-slate-200 rounded-md p-5 bg-white card-clinical">
                <div className="flex items-start justify-between">
                  <div>
                    <div className="font-mono text-[10px] uppercase tracking-widest text-blue-700">{p.category}</div>
                    <div className="mt-1 font-display text-lg font-semibold text-slate-900">{p.name}</div>
                    <div className="text-xs text-slate-500 mt-0.5">{p.chemical_name}</div>
                  </div>
                  <button onClick={() => remove(p.slug)} className="p-1.5 rounded-md hover:bg-red-50" data-testid={`remove-wishlist-${p.slug}`}><X className="w-4 h-4 text-red-500" strokeWidth={1.75}/></button>
                </div>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-slate-100">
                  <div className="font-display text-lg font-semibold text-slate-900">${p.price || m.price}</div>
                  <Link to={`/peptides/${p.slug}`} className="text-sm text-blue-700 hover:text-blue-800 inline-flex items-center gap-1">Details <ArrowRight className="w-4 h-4" strokeWidth={1.75}/></Link>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
